<template>
  <div id="categoriesComponent">
    <page-title :heading=heading :subheading=subheading :icon=icon></page-title>
    <v-container>
      <b-alert :show="noDefault" variant="warning">
        <v-layout class="align-center">
          <v-flex class="mr-3">
            <v-icon class="alert-link">fa-exclamation-triangle</v-icon>
            <!-- <h3><i class="fas fa-exclamation-triangle"></i></h3> -->
          </v-flex>
          <v-flex>
            <h3 class="text-sm-justify"> {{$t('categories.warning')}}</h3>
          </v-flex>
        </v-layout>
      </b-alert>
      <v-layout class="mb-2" wrap>
        <v-text-field
          v-model="categorySearch"
          :label="$t('general.search')"
          clearable
          append-outer-icon="search">
        </v-text-field>
        <v-spacer></v-spacer>
        <v-dialog persistent v-model="dialog" max-width="600px">
          <template v-slot:activator="{ on }">
            <v-btn
              color="primary"
              round
              outline
              v-on="on"
            >
              <v-icon left>category</v-icon>
              {{ $t('categories.add') }}
            </v-btn>
          </template>
          <v-card>
            <v-toolbar flat>
              <h2 class="font-weight-black primary--text mb-0">{{formTitle}}</h2>
            </v-toolbar>
            <v-card-text>
              <v-container grid-list-xs>
                <v-form
                  lazy-validation
                  ref="form"
                  v-model="valid"
                >
                  <v-container>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field
                          clearable
                          :label="$t('categories.description')"
                          :error-messages="errors.name"
                          v-model="editedItem.name"
                          :rules="rules.required"
                        >
                        </v-text-field>
                      </v-flex>
                      
                      <v-flex xs12 class="text-sm-right">
                        <v-checkbox
                          color="primary"
                          v-model="editedItem.default"
                          :label="$t('categories.setDefault')"
                          :value="1"
                        ></v-checkbox>
                      </v-flex>
                      <v-flex xs12 md12>
                          <v-checkbox
                            color="primary"
                            v-model="anAccount"
                            :label="$t('categories.AddanalyticalAccount')"
                          />
                      </v-flex>
                      <v-flex v-if="anAccount" xs12>
                        <v-text-field
                          v-model="editedItem.analytical_account"
                          clearable
                          :label="$t('categories.analyticalAccount')"
                          :error-messages="errors.analytical_account"
                          :rules="rules.charactersMax100">
                        </v-text-field>
                      </v-flex>
                      <v-flex v-if="anAccount && applyFeatures" xs12>
                        <v-text-field
                          v-model="editedItem.analytical_description"
                          clearable
                          :label="$t('categories.analyticalDescription')"
                          :error-messages="errors.analytical_description"
                          :rules="rules.charactersMax100">
                        </v-text-field>
                      </v-flex>
                      <v-flex v-if="anAccount && applyFeatures" xs12>
                        <v-text-field
                          v-model="editedItem.accounting_account"
                          clearable
                          :label="$t('categories.accountingAccount')"
                          :error-messages="errors.accounting_account"
                          :rules="rules.charactersMax100">
                        </v-text-field>
                      </v-flex>
                      <v-flex v-if="anAccount && applyFeatures" xs12>
                        <v-text-field
                          v-model="editedItem.accounting_description"
                          clearable
                          :label="$t('categories.accountingDescription')"
                          :error-messages="errors.accounting_description"
                          :rules="rules.charactersMax100">
                        </v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary darken-1"
                round
                flat
                @click="close"
              >
                {{ $t('general.cancel') }}
              </v-btn>
              <v-btn
                :loading="loading"
                :disabled="loading"
                color="primary"
                round
                depressed
                @click="save"
              >
                {{ $t('general.submit') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
      <v-data-table
        style="width: 100%"
        :search="categorySearch"
        class="elevation-2"
        :headers="headers"
        :items="categories"
        :loading="loadingItems"
        :rows-per-page-items="[10,15,25]"
        :pagination.sync="pagination"
      >
      <template v-slot:headers="props">
        <tr class="bg-heavy-rain">
          <th
            v-for="header in props.headers"
            :key="header.text"
            :class="['column', header.sortable ? 'sortable' : '', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
            @click="changeSort(header.value)"
            >
            <h2 class="font-weight-black primary--text mb-0">
              <v-icon small class="primary--text" v-if="header.sortable">arrow_upward</v-icon>
              {{ header.text }}
            </h2>
          </th>
        </tr>
      </template>
      <template v-slot:items="props">
          <tr>
              <td class="text-sm-center" style="width: 10%">{{props.item.id}}</td>
              <td class="text-sm-center" style="width: 50%">{{props.item.name}}</td>
              <td class="text-sm-center">
              <v-icon v-if="props.item.default === 1" color="success" left>check_circle</v-icon>
            </td>
              <td class="text-sm-center" v-if="applyFeatures" style="width: 10%">{{props.item.accounting_account}}</td>
              <td class="text-sm-center" v-if="applyFeatures" style="width: 10%">{{props.item.analytical_account}}</td>
              <td class="text-sm-center" style="width: 20%">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      small
                      outline
                      icon
                      color="info"
                      v-on="on"
                      @click="editItem(props.item)"
                    >
                      <v-icon small>edit</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('general.edit') }}</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                  <v-btn
                    small
                    outline
                    icon
                    color="error"
                    v-on="on"
                    @click="removed(props.item)"
                  >
                    <v-icon small>delete</v-icon>
                  </v-btn>
                  </template>
                  <span>{{ $t('general.delete') }}</span>
                </v-tooltip>
              </td>
          </tr>
      </template>
      </v-data-table>
      <v-dialog persistent v-model="removeDialog" max-width="600px">
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black error--text mb-0">{{ $t('categories.delete') }}</h2>
          </v-toolbar>
          <v-card-text class="text-sm-justify">
            <p>{{ $t('general.deleteElementQuestion') }}</p>
            <p class="font-weight-black"><span class="error--text">{{ $t('categories.description') }}: </span>{{removedItem.name}}</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error darken-1"
              round
              flat
              @click="removeDialog = false"
            >
              {{ $t('general.cancel') }}
            </v-btn>
            <v-btn
              :loading="loading"
              :disabled="loading"
              color="error"
              round
              depressed
              @click="removeItem(removedItem)"
            >
              {{ $t('general.delete') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
export default {
  name: 'categoriesComponent',
  data () {
    return {
      anAccount: false,
      categorySearch: '',
      noDefault: false,
      pagination: {
        sortBy: 'name',
        descending: false,
        page: 1,
        rowsPerPage: 15,
        totalItems: 0
      },
      dialog: false,
      loading: false,
      loadingItems: true,
      removeDialog: false,
      valid: true,
      errors: {},
      editedIndex: -1,
      removedItem: {},
      originalItem: {},
      editedItem: {
        id: 0,
        name: '',
        company_id: 0,
        default: 0,
        category_group: '',
        analytical_account: '',
        analytical_description: '',
        accounting_account: '',
        accounting_description: ''
      },
      defaultItem: {
        id: 0,
        name: '',
        company_id: 0,
        default: 0,
        category_group: '',
        analytical_account: '',
        analytical_description: '',
        accounting_account: '',
        accounting_description: ''
      },
      categories: []
    }
  },
  computed: {
    applyFeatures () {
      if (this.$store.state.userLogged.company === undefined) {
        return false
      }

      if (this.$store.state.userLogged.company[0].features.find(x => x.name === 'CATALOG_EXTRA_FIELDS_FREY')) {
        return true
      }

      return false
    },
    heading () {
      return this.$t('general.categories')
    },
    subheading () {
      return ''
    },
    icon () {
      return 'fas fa-shapes fa-fw icon-color'
    },
    formTitle () {
      return this.editedIndex === -1 ? this.$t('categories.new') : this.$t('categories.edit')
    },
    headers () {
      const headersArray = [
        {
          text: '#',
          align: 'center',
          sortable: true,
          value: 'id'
        },
        {
          text: this.$t('general.name'),
          align: 'center',
          value: 'name',
          sortable: true
        },
        {
          text: this.$t('general.defaults'),
          align: 'center',
          sortable: true
        },
        {
          text: this.$t('categories.accountingAccount'),
          align: 'center',
          value: 'accountingAccount',
          sortable: true
        },
        {
          text: this.$t('categories.analyticalAccount'),
          align: 'center',
          value: 'analyticalAccount',
          sortable: true
        },
        {
          text: this.$t('general.actions'),
          align: 'center',
          sortable: false
        }
      ]
      const showExtraFields = this.applyFeatures
      if (!showExtraFields) {
        const indexToRemoveStart = 2
        const numberOfHeadersToRemove = 2
        headersArray.splice(indexToRemoveStart, numberOfHeadersToRemove)
      }
      return headersArray
    },
    rules () {
      return this.$validationRules()
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    categories () {
      if (this.categories.length > 0) {
        if (this.categories.find(item => item.default === 1)) {
          this.noDefault = false
        } else {
          this.noDefault = true
        }
      } else {
        this.noDefault = true
      }
    }
  },
  created () {
    this.initialize()
  },
  methods: {
    changeSort (header) {
      if (this.pagination.sortBy === header) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.descending = false
      }
      this.pagination.sortBy = header
    },
    removed (item) {
      this.removedItem = item
      this.removeDialog = true
    },
    removeItem (item) {
      const index = this.categories.indexOf(item)
      this.delete(item, index)
      this.loading = true
      // this.categories.splice(index, 1)
    },
    close () {
      this.dialog = false
      this.loading = false
      this.errors = {}
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1
      this.$refs.form.resetValidation()
      this.anAccount = false
    },
    closeRemove () {
      this.removeDialog = false
      this.loading = false
    },
    editItem (item) {
      this.anAccount = !!item.analytical_account
      this.editedIndex = this.categories.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    save () {
      // applyFeatures valida si aplica los cambios trabajados
      if (!this.editedItem.name && this.applyFeatures) {
        this.$refs.form && this.$refs.form.validate()
        if (this.editedItem.category_group && this.editedItem.analytical_description) {
          const abbreviationMap = {
            'Gasto en General': 'GG',
            'Costo de Obra': 'CO'
          }
          const initials = abbreviationMap[this.editedItem.category_group] || this.editedItem.category_group.substring(0, 2)
          this.editedItem.name = `${initials} - ${this.editedItem.analytical_description}`
        } else {
          console.error('No se pueden dejar campos vacíos.')
          return
        }
      }

      if (!this.$refs.form.validate() && !this.applyFeatures) return false // applyFeatures valida si aplica los cambios trabajados

      if (this.editedIndex > -1) {
        this.put()
      } else {
        this.post()
      }
      this.loading = true
    },
    initialize () {
      this.$emit('getCategories', {context: this})
    },
    post () {
      this.$emit('postCategory', {item: this.editedItem, context: this})
    },
    put () {
      this.$emit('putCategory', { item: this.editedItem, index: this.editedIndex, context: this })
    },
    delete (item, index) {
      this.$emit('deleteCategory', {
        item: item,
        index: index,
        context: this
      }
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/categories.component.vue